<!--
 * 查询货品多选分页：首页 / 上一页 / 页码 / 下一页 / 末页
 * 对外抛出 skip、count、currentPage，与接口分页参数一致
-->
<template>
    <div class="pageCon">
        <div class="page_info">共 {{ total }} 条</div>
        <div class="page_ops">
            <div class="pg_btn" :class="{ disabled: firstPageBtnDisabled }" @click="toFirstPage">首页</div>
            <div class="pg_btn" :class="{ disabled: firstPageBtnDisabled }" @click="toPrevPage">上一页</div>
            <div
                class="page_num"
                :class="{ active: paginationOptions.currentPage === page }"
                v-for="page in visiblePages"
                :key="page"
                @click="handleCurrentChange(page)"
            >{{ page }}</div>
            <div class="pg_btn" :class="{ disabled: lastPageBtnDisabled }" @click="toNextPage">下一页</div>
            <div class="pg_btn" :class="{ disabled: lastPageBtnDisabled }" @click="toLastPage">末页</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'paginationPanel',
    props: {
        total: {
            type: Number,
            default: 0
        },
        reset: {
            type: Boolean,
            default: false
        },
        /** 每页条数，多选固定 100 */
        pageSize: {
            type: Number,
            default: 100
        },
        /** 中间最多展示的页码个数 */
        maxVisible: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            paginationOptions: {
                skip: 0,
                count: 100,
                currentPage: 1
            },
            firstPageBtnDisabled: true,
            lastPageBtnDisabled: true
        }
    },
    computed: {
        lastPageNum() {
            if (!this.total || this.total <= 0) return 1;
            return Math.ceil(this.total / this.paginationOptions.count) || 1;
        },
        visiblePages() {
            const totalPages = this.lastPageNum;
            const current = this.paginationOptions.currentPage;
            const max = this.maxVisible;
            if (totalPages <= max) {
                return Array.from({ length: totalPages }, (_, i) => i + 1);
            }
            let start = Math.max(1, current - Math.floor(max / 2));
            let end = start + max - 1;
            if (end > totalPages) {
                end = totalPages;
                start = end - max + 1;
            }
            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        }
    },
    watch: {
        reset(val) {
            if (val) {
                this.paginationOptions.currentPage = 1;
                this.paginationOptions.skip = 0;
                this.paginationOptions.count = this.pageSize;
                this.updateBtnDisabled(1);
            }
        },
        total() {
            this.updateBtnDisabled(this.paginationOptions.currentPage);
        },
        pageSize: {
            immediate: true,
            handler(val) {
                this.paginationOptions.count = val;
            }
        }
    },
    methods: {
        updateBtnDisabled(val) {
            this.firstPageBtnDisabled = val === 1;
            if (this.total == 0) {
                this.lastPageBtnDisabled = true;
            } else {
                this.lastPageBtnDisabled = val === this.lastPageNum;
            }
        },
        handleCurrentChange(val) {
            if (!val || val === this.paginationOptions.currentPage) return;
            if (val < 1 || val > this.lastPageNum) return;
            this.updateBtnDisabled(val);
            this.paginationOptions.currentPage = val;
            this.paginationOptions.skip =
                (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
            this.paginationOptions.skip =
                this.paginationOptions.skip < 0 ? 0 : this.paginationOptions.skip;
            this.$emit('onPaginationChange', Object.assign({}, this.paginationOptions));
        },
        toFirstPage() {
            if (this.firstPageBtnDisabled) return;
            this.handleCurrentChange(1);
        },
        toPrevPage() {
            if (this.firstPageBtnDisabled) return;
            this.handleCurrentChange(this.paginationOptions.currentPage - 1);
        },
        toNextPage() {
            if (this.lastPageBtnDisabled) return;
            this.handleCurrentChange(this.paginationOptions.currentPage + 1);
        },
        toLastPage() {
            if (this.lastPageBtnDisabled) return;
            this.handleCurrentChange(this.lastPageNum);
        }
    }
}
</script>

<style lang="scss" scoped>
.pageCon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.8vw;
    padding: 0 2.93vw;
    box-sizing: border-box;
    background: #fff;
    border-top: 1PX solid #EEF0F3;

    .page_info {
        font-size: 0.95vw;
        color: #86909C;
        flex-shrink: 0;
    }

    .page_ops {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    .pg_btn,
    .page_num {
        min-width: 2.6vw;
        height: 2.4vw;
        padding: 0 0.6vw;
        margin-left: 0.4vw;
        box-sizing: border-box;
        border-radius: 0.29vw;
        border: 1PX solid #D8DCE5;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.95vw;
        color: #1A1A1A;
        background: #fff;
        white-space: nowrap;
    }

    .pg_btn.disabled {
        color: #C9CDD4;
        background: #F7F8FA;
        border-color: #E5E6EB;
        pointer-events: none;
    }

    .page_num.active {
        background: #CEB57D;
        border-color: #CEB57D;
        color: #fff;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/padViews/allot/components/paginationPanel.vue